import { render, staticRenderFns } from "./ConnectionsTabPanel.vue?vue&type=template&id=5251f3b6&"
import script from "./ConnectionsTabPanel.vue?vue&type=script&lang=js&"
export * from "./ConnectionsTabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports